import { RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import useOnline from "../hooks/useOnline";
import useServerVersion from "../hooks/useServerVersion";
import { bundleInfo, isNewerVersionAvailable } from "../lib/appVersion";

// Shown under the header when the server runs a newer version than the code this tab loaded (lot 29, V2). Never blocks: the person
// reloads when it suits them — nothing typed is thrown away by the banner itself.
export default function UpdateBanner() {
  const serverVersion = useServerVersion();
  const online = useOnline();
  const { version } = bundleInfo();
  if (!online || !isNewerVersionAvailable(version, serverVersion)) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-teal-200 bg-teal-50 px-4 py-2 text-sm text-teal-900" role="status" data-testid="update-banner">
      <RefreshCw size={16} className="shrink-0" aria-hidden />
      <span className="min-w-0 flex-1">Une nouvelle version de Jamora CRM est disponible ({serverVersion}). Enregistrez votre travail, puis actualisez pour la charger.</span>
      <Button size="sm" onClick={() => window.location.reload()} data-testid="update-banner-reload">Actualiser</Button>
    </div>
  );
}
